import './sidebar.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { injectIntl, FormattedMessage } from 'react-intl';
import Logo from 'hellosign/components/app/logo-v2';
import { getBrandName } from 'js/sign-components/common/brand';

/**
 * @typedef {Object} Item
 * @property {string} url
 * @property {string} label
 * @property {string} qaRef
 * @property {Item[]} [subtree]
 */

class CondorSidebar extends React.Component {

  static propTypes = {
    intl: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    permissions: PropTypes.object.isRequired,
    items: PropTypes.array,
    siteCode: PropTypes.string,
  };

  /**
   * @param {Item[]}
   * @returns {Array.<JSX.Fragment>}
   */
  renderItems(items) {
    const { permissions } = this.props;

    return (
      <ul className="condor-sidebar__links-list">
        {items.map((link, i) => {
          const { url, label, qaRef, permissionSet, items: subItems } = link;

          // If item permissions are defined and permissions
          // resolve to false, return null.
          if (permissionSet) {
            for (let i = 0, len = permissionSet.length; i < len; i++) {
              const permission = permissionSet[i];

              if (!permissions[permission]) {
                return null;
              }
            }
          }

          return (
            <li key={i} className="condor-sidebar__links-list-item">
              <NavLink
                to={url}
                data-testid={qaRef}
                className="condor-sidebar__link"
                activeClassName="condor-sidebar__link--is-active"
              >
                {label}
              </NavLink>
              {subItems && this.renderItems(subItems)}
            </li>
          );
        })}
      </ul>
    );
  }

  render() {
    const { items, siteCode } = this.props;

    return (
      <div className="condor-sidebar container">
        <div className="condor-sidebar__logo row">
          <div className="col">
            <Logo
              className="condor-sidebar__logo-img"
              siteCode={siteCode}
              variant="wordmark"
              size={40} />
          </div>
        </div>
        <div className="condor-sidebar__title row pt-4">
          <div className="col">
            <p className="condor-sidebar__title-text">
              {this.props.title}
            </p>
          </div>
        </div>
        <div className="condor-sidebar__links pt-2 row">
          <div className="col py-4">
            {items && this.renderItems(items)}
          </div>
        </div>
        <div className="condor-sidebar__return row">
          <div className="col">
            <div className="condor-sidebar__return-link-container py-4">
              <a className="condor-sidebar__return-link" href="/" data-qa-ref="home-tab">
                <FormattedMessage
                  id=""
                  description="A link that when clicked will return the user to the main app."
                  defaultMessage="Return to {brandName}"
                  values={{
                    brandName: getBrandName('S'),
                  }} />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(CondorSidebar);
